/**
 * RS Ph3 bugfix — pure helper extracted from ResendStep2 so it's
 * unit-testable without mounting the full React tree.
 *
 *   resolveRuleCarrier — given the rule's `assignedCarrierUid` and the
 *   freshly-fetched carrier list, find the matching carrier (by uid).
 *   Falls back to slug match. Bug 1: previous code used carriers[0]
 *   unconditionally.
 *
 * (The override-detection helper was removed in SRE-2: shipping rules are
 * binding, so there is no override to detect.)
 */

export interface CarrierLite {
  carrier_slug: string;
  carrier_name?: string;
  carrier_uid?: string | null;
}

export const resolveRuleCarrier = <T extends CarrierLite>(
  carriers: T[] | undefined | null,
  assignedCarrierUid: string | null | undefined,
  assignedCarrierSlug?: string | null,
): T | null => {
  if (!carriers || carriers.length === 0) return null;
  if (assignedCarrierUid) {
    const byUid = carriers.find((c) => c.carrier_uid && c.carrier_uid === assignedCarrierUid);
    if (byUid) return byUid;
  }
  if (assignedCarrierSlug) {
    const bySlug = carriers.find((c) => c.carrier_slug === assignedCarrierSlug);
    if (bySlug) return bySlug;
  }
  return null;
};
